"use strict";
exports.__esModule = true;
exports.typeStyles = void 0;
var tokens_1 = require("./tokens");
exports.typeStyles = {
    headingText: {
        fontFamily: tokens_1.FontFamilies.Inter
    },
    featureText: {
        fontFamily: tokens_1.FontFamilies.Feature
    },
    nationalText: {
        fontFamily: tokens_1.FontFamilies.National
    },
    bodyText: {
        fontFamily: tokens_1.FontFamilies.Inter
    },
    monoText: {
        fontFamily: tokens_1.FontFamilies.IBMPlexMono
    }
};
